import React, { Component } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {
  getOutgoingCalls,
  getIncomingCalls,
  getQueuedCalls,
  getAuotoDialerCalls
} from '../../actions/getCalls';
import {doCall, showWebphone} from '../../actions/call';
import CallMenu from '../call-menu.js';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import orderBy from 'lodash/orderBy';
//import Autosuggest from 'react-bootstrap-autosuggest';
//import { Typeahead } from 'react-bootstrap-typeahead';
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import timezones from '../../utils/timezones';
import Loader from '../Components/Loader';
import { logData, pasteHandler, keyDownHandler } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

// this container is same for outgoing, incoming, autoDialer and queued calls
class CallsModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
        isShow: false,
        showErr: false,
        showCallsModal:props.showCallsModal,
        perPage: 100,
        activePage: 1,
        callsData: this.props.callsData,
        displayingCalls: [],
        displayingCallsAll: [],
        loading: false,
        totalData: 100,
        dateViewMode: 'days',
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        startDateDefault: moment().subtract(7, 'days'),
        endDate: moment().format('YYYY-MM-DD'),
        endDateDefault: moment(),
        tomorrow: Datetime.moment().add( 1, 'day' ),
        link_disabled: false,
    };
  }

  // checks if date is valid
  validDate = (current) => {
      return current.isBefore( this.state.yesterday );
  };

  resetFilters = () => {
    const colFilters = {};
    this.props.columns.forEach(col => {
      if(col.filter){
        colFilters[col.key] = '';
      }
    });
    return colFilters;
  }

  // handleSelect = (eventKey) => {
  //   // const data = this.props.callsData.slice((eventKey - 1) * this.state.perPage, eventKey * this.state.perPage);
  //   this.setState({
  //     activePage: eventKey,
  //     loading: true,
  //     // displayingCalls: data
  //   }, () => {
  //     this.getCallsData();
  //   });
  // }

  // updates state with column filters with empty value among other stuff and gets call data
  handleEnter = () => {
    // const data = this.props.callsData.slice((this.state.activePage - 1) * this.state.perPage, this.state.activePage * this.state.perPage);
    // this.setState({
    //   paginationItems: Math.round(this.props.callsData.length / this.state.perPage),
    //   displayingCalls: data
    // });
    this.setState({
      loading: true,
      startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      // selectedTimezone: moment.tz.guess()
      selectedTimezone: this.props.agentInfo.timezone,
    }, () => {
      this.getCallsData();
    });
  }
  // gets the data for calls with backend filters for pagination.
  getCallsData = () => {

    let { translations, selectedLanguage } = this.props;
    if(this.state.startDate > this.state.endDate) {
      this.setState({errorMsg: translations.dateSelectionErrMsg[selectedLanguage], showErr: true});
      return;
    }
    
    const colFilters = this.resetFilters();
    logData(colFilters);
    this.setState({
      loading: true,
      ...colFilters
    }, () => {
      let filter = {
        num_calls: this.state.perPage,
        offset: (this.state.activePage - 1) * this.state.perPage,
        begin_date: this.state.startDate,
        end_date: this.state.endDate,
        time_zone: this.state.selectedTimezone,
        today_only: 0
      };
      // dynamically calling action.
      this.props[this.props.callAction](filter).then((res) => {
        //this.props[this.props.callAction]();
        const mappedCalls = res.data.response[this.props.callDataParam].map(item => {
          this.props.columns.forEach(col => {
            if(col.operation === 'subtract'){
              if(item[col.firstItem] !== null && item[col.secondItem] !== null){
                item[col.key] = item[col.firstItem] - item[col.secondItem];
              }else{
                item[col.key] = 0;
              }
            }
          });
          return item;
        });
        this.setState({
          loading: false,
          displayingCalls: mappedCalls,
          displayingCallsAll: mappedCalls,
          paginationItems: Math.round(this.state.totalData / this.state.perPage),
          appliedTimezone: this.state.selectedTimezone
        });
      }, (err) => {
        logData(err);
        this.setState({
          showErr: true,
          loading: false,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
        });
      });
    });
  }
  // fake a blur event when input is clicked to keep it opened
  handleDatepickerFocus = () => {
    document.getElementById('startDateId').blur();
    document.getElementById('endDateId').blur();
  }

  // makes outgoing call
  // Llamar desde el panel de ver mas.
  makeCall = (e) => {
      if (! this.state.link_disabled)
      {
          // console.log('CLICK no more!! Panel Llamadas ver mas');
          this.state.link_disabled = true;
          setTimeout(() => { 
              this.state.link_disabled = false;
              // console.log('CLICK ok!! Panel Llamadas ver mas');
          }, 5000);

          // console.log('LLAMAR POR VER MAS de toos');
          this.props.showWebphone(true);
          const payload = {
              phoneNumber: e.target.id
    	  };
    	  this.props.doCall(payload);
	  }
  }

  // getCallMenuProps = (item, props) => {
  //   const obj = {};
  //   for (const key in props) {
  //     if (props.hasOwnProperty(key)) {
  //       obj[key] = item[props[key]];
  //     }
  //   }
  //   return obj;
  // }

  /**
   * updates call list with updated end business
   * @param  {string} callId
   * @param  {string} end_business_id
   * @param  {string} end_business    name of end business
   */
  outgoingServiceCb = (callId, end_business_id, end_business) => {
    const displayingCalls = this.state.displayingCalls.map(item => item.call_id!==callId ? item : {...item, end_business_id, end_business});
    this.setState({
      displayingCalls,
      displayingCallsAll: displayingCalls
    });
    
    if(this.props.panelOutgoingServiceCb) {
      this.props.panelOutgoingServiceCb(callId, end_business_id, end_business);
    }
  }

  // updates schedule date for current calls.
  rescheduleCallCb = (callId, schedule_date, schedule_service) => {
    const displayingCalls = this.state.displayingCalls.map(item => item.call_id!==callId ? item : {...item, schedule_date, schedule_service});
    this.setState({
      displayingCalls,
      displayingCallsAll: displayingCalls
    });

    if(this.props.panelRescheduleCallCb) {
      this.props.panelRescheduleCallCb(callId, schedule_date, schedule_service);
    }
  }

  getCalls = () => {
    this.getCallsData();

    if(this.props.panelGetCalls) {
      this.props.panelGetCalls();
    }
  }

  // closes modal when reopen tab is clicked.
  reopenTabCb = () => {
    this.close('showCallsModal');
  }

  /**
   * Gets value that needs to be displayed for table column.
   * compares for different column types.
   * @param  {object} item contact data
   * @param  {object} col  column data
   * @return {string}      value that needs to be displayed
   */
  getColumnValue = (item, col) => {
    let value = item[col.key];
    if(col.time){
      value = moment.tz(item[col.key] * 1000, this.state.appliedTimezone).format('DD-MM-YYYY HH:mm');
    }
    if(col.operation === 'subtract'){
      if(item[col.firstItem] !== null && item[col.secondItem] !== null){
        value = item[col.firstItem] - item[col.secondItem];
      }else{
        value = 0;
      }
    }
    return value;
  }

  // renders list of calls. loops through list data and columns
  renderCalls = () => {
		return this.state.displayingCalls.map((item) => {
      return (
				<tr key={item.call_id}>
          {this.props.columns.map((col) => {
            const extraAtrr = col.doCall ? {
              onClick: this.makeCall,
              id: item[col.key],
              className: 'cursor'
            } : {};
            return (
              <td
                style={ {...col.style} }
                key={col.key}
                {...extraAtrr}
              >
                { this.getColumnValue(item, col) }
              </td>
            )
          })}
          { this.props.type === 'outgoing' &&
          <td style={{width:81}}>
            <CallMenu
							CallId={item.call_id}
							listDetailId={item.list_detail_id}
							phoneNumber={item.destination_phone}
							serviceId={item.service_id}
							disableOptions={item.end_business_id !== 0}
              endBusinessId={parseInt(item.end_business_id)}
              endBusiness={item.end_business}
              getCalls={this.getCalls}
              has_tags={item.has_tags}
              outgoingServiceCb={ this.outgoingServiceCb }
              rescheduleCallCb={ this.rescheduleCallCb }
              scheduleDate={ item.schedule_date }
              scheduleService={ item.schedule_service || ''}
              reopenTabCb={ this.reopenTabCb }
              type="outgoing"
						/>
					</td>
          }
          { this.props.type === 'incoming' &&
          <td style={{width:81}}>
            <CallMenu
							CallId={item.call_id}
							listDetailId={item.list_detail_id}
							phoneNumber={item.origin_phone}
							serviceId={item.service_id}
              disableOptions={item.end_business_id !== 0}
              endBusinessId={parseInt(item.end_business_id)}
              endBusiness={item.end_business}
              getCalls={this.getCalls}
              has_tags={item.has_tags}
              outgoingServiceCb={ this.outgoingServiceCb }
              scheduleDate={ item.schedule_date }
              scheduleService={ item.schedule_service || ''}
              rescheduleCallCb={ this.rescheduleCallCb }
              reopenTabCb={ this.reopenTabCb }
              type="incoming"
						/>
					</td>
          }
          { this.props.type === 'autoDialer' &&
          <td style={{width:81}}>
            <CallMenu
							CallId={item.call_id}
							listDetailId={item.list_detail_id}
							phoneNumber={item.called_phone}
							serviceId={item.service_id}
							disableOptions={parseInt(item.end_business_id) !== 0}
              endBusinessId={parseInt(item.end_business_id)}
              endBusiness={item.end_business_call_name}
              has_tags={item.has_tags}
              getCalls={this.getCalls}
              outgoingServiceCb={ this.outgoingServiceCb }
              rescheduleCallCb={ this.rescheduleCallCb }
              scheduleDate={ item.schedule_date }
              scheduleService={ item.schedule_service || ''}
              reopenTabCb={ this.reopenTabCb }
              type="outgoing"
						/>
					</td>
          }
				</tr>
      );
    });
	}

  // render header for table
  renderHeader = () => {
    return this.props.columns.map((item, key) => {
      return (
        <th
          style={ {...item.style, position: 'relative', cursor: 'pointer'} }
          key={key}
          id={ item.key }
          onClick={ this.handleSort }
        >
          {item.title.length>0 ? this.props.translations[item.title][this.props.selectedLanguage] : ''}
          {this.state[`${item.key}Sort`] && <span
            className={ this.state[`${item.key}Sort`] == 'desc' ? 'headerSortUp' : 'headerSortDown' }
            style={ {color: 'rgba(0, 0, 0, 0.5)', position: 'absolute', right: '20px'} }
            aria-hidden="true"
            id={ item.key }
            onClick={ this.handleSort }
          />}
        </th>
      );
    });
  }
  // shows filters for columns where it needs to be added
  renderFilters = () => {
    return this.props.columns.map((item, key) => {
      return (
        <td
          style={ {...item.style} }
          key={key}
          id={ item.key }
        >
          {item.filter &&
            <input
              type="text"
              className={`form-control${this.props.theme} input-sm${this.props.theme}`}
              id={ item.key }
              onChange={ this.handleCallsFilterChange }
              onKeyDown={item.title === "number" ? 
                (event) => keyDownHandler(event, "allowNumbersAndChars") : 
                ""
              }
              onPaste={
                item.title === "number" ? 
                (event) => pasteHandler(event, "allowNumbersAndChars") : 
                ""
              }
              value={ this.state[item.key] }
            />
          }
        </td>
      );
    });
  }
  // handles sorting of table
  handleSort = (e) => {
    const sortType = this.state[`${e.target.id}Sort`] == 'desc' ? 'asc' : 'desc';
    const orderedData = orderBy(this.state.displayingCalls, e.target.id, sortType);
    const orderedDataAll = orderBy(this.state.displayingCallsAll, e.target.id, sortType);
    const colSorts = {};
    this.props.columns.forEach(col => {
      colSorts[`${[col.key]}Sort`] = null
    });
    this.setState({
      ...colSorts,
      [`${e.target.id}Sort`]: sortType,
      displayingCalls: orderedData,
      displayingCallsAll: orderedDataAll,
    });
  }
  // updates selected timezone
  handleTimezoneSelect = (data) => {
    this.setState({
      selectedTimezone: data? data.value : ''
    });
  }
  // updates start date
  handleStartDate = (date) => {
    this.setState({
      startDate: moment(date).format('YYYY-MM-DD')
    });
  }
  // updates end date
  handleEndDate = (date) => {
    this.setState({
      endDate: moment(date).format('YYYY-MM-DD')
    });
  }
  // filters data
  handleCallsFilterChange = (e) => {
    const key = e.target.id;
    const filterValue = e.target.value;
    this.setState({
      [key]: filterValue
    }, () => {
      let filteredList = this.state.displayingCallsAll;
      this.props.columns.forEach(col => {
        if(col.filter){
          filteredList = filteredList.filter(item =>
            item[col.key] ?
            item[col.key].toLowerCase().includes(this.state[col.key].toLowerCase())
            : null
          );
        }
      });
      // const filteredList = this.state.displayingCallsAll.filter(item =>
      //     item[key].toLowerCase().includes(filterValue.toLowerCase()));
      this.setState({
        displayingCalls: filteredList
      });
    })
  }

  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });
  }
  // gets text according to type of modal opened
  getNoCallText = () => {
    const translations = {
      outgoing: 'noOutgoingCalls',
      incoming: 'noIncomingCalls',
      queue: 'noCallsInQueue',
      autoDialer: 'noAutoDialerCalls'
    }
    let text = this.props.translations[translations[this.props.type]][this.props.selectedLanguage];
    return text;
  }

  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  render(){
    const {
      translations, selectedLanguage
    } = this.props;
    const {
      startDateDefault,
      endDateDefault
    } = this.state;
    return (
      <Modal
        dialogClassName="extraLarge"
        bsSize="lg"
        onEnter={this.handleEnter}
        show={this.props.showCallsModal}
        onHide={() => this.close('showCallsModal')}
        backdrop="static"
      >
         <Modal.Header className={`modal-content1${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{this.props.headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content1${this.props.theme}`} style={ { maxHeight: '100%' } }>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          <div className="row" style={ {marginBottom: 15} }>
            <div className="col-sm-3 autosuggestion">
              <div className="form-group">
              <Select
                value={this.state.selectedTimezone}
                onChange={this.handleTimezoneSelect}
                placeholder="select"
                options={timezones}
                labelKey="name"
                valueKey="value"
              />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
              <Datetime
                locale={selectedLanguage}
                viewMode={this.state.dateViewMode}
                onChange={this.handleStartDate}
                timeFormat={ false }
                closeOnSelect
                defaultValue={ startDateDefault }
                dateFormat="DD/MM/YYYY"
                isValidDate={ this.validDate }
                inputProps={{onClick: this.handleDatepickerFocus, id: 'startDateId' }}
              />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
              <Datetime
                locale={selectedLanguage}
                viewMode={this.state.dateViewMode}
                onChange={this.handleEndDate}
                timeFormat={ false }
                closeOnSelect
                defaultValue={ endDateDefault }
                dateFormat="DD/MM/YYYY"
                isValidDate={ this.validDate }
                inputProps={{onClick: this.handleDatepickerFocus, id: 'endDateId' }}
              />
              </div>
            </div>
            <div className="col-sm-3">
              <Button onClick={ this.getCallsData }>{translations.apply[selectedLanguage]}</Button>
            </div>
          </div>
          <div className="table-responsive">
						<table className={`table-fixed table table${this.props.theme} table-hover${this.props.theme} m-a-0`}>
							<thead>
								<tr>
									{this.renderHeader()}
                  <th />
								</tr>
                <tr>
									{this.renderFilters()}
                  <td />
								</tr>
							</thead>
              <tbody style={{maxHeight: 300, minHeight: this.state.displayingCalls.length > 0 ? 300 : '', paddingRight: 17}}>
                {this.state.loading && <h3><Loader width="20px" height="20px" /></h3>}
								{!this.state.loading && this.renderCalls()}
							</tbody>
						</table>
            {(!this.state.loading && this.state.displayingCalls.length == 0) &&
              <h3 style={ {textAlign: 'center'} }>{this.getNoCallText()}</h3>}
					</div>
        </Modal.Body>
        <Modal.Footer className={`modal-content1${this.props.theme}`}>
          <nav className="text-center">
          {/* <Pagination
          bsSize="sm"
          items={this.state.paginationItems}
          activePage={this.state.activePage}
          onSelect={this.handleSelect} /> */}
          </nav>
        <br />
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        outgoingCalls: state.outgoingCalls,
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}

const mapDispatchToProps = {
  getOutgoingCalls,
  getIncomingCalls,
  getQueuedCalls,
  getAuotoDialerCalls,
  doCall,
  showWebphone
}

export default connect(mapStateToProps, mapDispatchToProps)(CallsModal);



// WEBPACK FOOTER //
// ./src/agent/modals/callsModal.js